import { useReducer, useEffect } from 'react';
import { OnboardingState, OnboardingAction } from '../onboarding.types';

const STORAGE_KEY = 'konekt_onboarding_state';

const initialState: OnboardingState = {
  currentStep: 0,
  school: null,
  terms: [],
  classrooms: [],
  feeStructure: {},
  admins: [],
};

function reducer(state: OnboardingState, action: OnboardingAction): OnboardingState {
  switch (action.type) {
    case 'SET_STEP':
      return { ...state, currentStep: action.payload };
    case 'SET_SCHOOL':
      return { ...state, school: action.payload };
    case 'SET_TERMS':
      return { ...state, terms: action.payload };
    case 'SET_CLASSROOMS':
      return { ...state, classrooms: action.payload };
    case 'SET_FEE_STRUCTURE':
      return { ...state, feeStructure: action.payload };
    case 'SET_ADMINS':
      return { ...state, admins: action.payload };
    case 'RESET':
      sessionStorage.removeItem(STORAGE_KEY);
      return initialState;
    default:
      return state;
  }
}

function loadFromStorage(): OnboardingState {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (raw) return JSON.parse(raw);
  } catch {
    // ignore parse errors
  }
  return initialState;
}

export function useOnboardingState() {
  const [state, dispatch] = useReducer(reducer, undefined, loadFromStorage);

  useEffect(() => {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  }, [state]);

  return { state, dispatch };
}
